import { useRef } from 'react'
import searchIcon from '../assets/new-ui/search-icon.png'

export default function CustomSearch(props) {
  const { placeholder, searching } = props
  const refSearch = useRef()

  return (
    <div className='customSearch' onClick={() => refSearch.current.focus()}>
      <input onChange={(e) => searching(e.target.value)} ref={refSearch} placeholder={placeholder}/>
      <img src={searchIcon} alt='search icon' />
    </div>
  )
}